module.exports = __webpack_public_path__ + "b521397d64995eaf5d7b11ab270236ee.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Modal/images/large/vr-museum.jpg
 ** module id = 406
 ** module chunks = 0
 **/